import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Form from "./Form";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const rawNext = params.get("next");
  const next = rawNext ? decodeURIComponent(rawNext) : "/dataset-submissions";

  return (
    <Form
      route="/token/"
      method="login"
      onSuccess={() => {
        alert("Login successful!");
        navigate(next, { replace: true });
      }}
    />
  );
};

export default Login;

